import { call, put, takeLatest, takeEvery, fork, all, delay } from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as Func from "../helpers/functions";
import { parseListRequestParamsCameo, getLocaleFullName } from '../utils/commonUtils';
import i18n from '../constants/initLng';
import history from '../helpers/history';
import * as RateCodeAction from '../actions/rateCodeAction';
import * as RateCodeServie from './../services/rateCodeService';
import { PATHS, SAGA_DELAY_TIMEOUT } from '../constants/Define';

function* getListRateCodeCampaign() {
    yield takeLatest(Types.RATECODE_CAMPAIGN_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseListRequestParamsCameo(action.params || {});
        const result = yield call(RateCodeServie.getRateCodeCampaignList, params);
        yield put(RateCodeAction.setRateCodeCampaignList(result));
    }, errorHandleRateCode(Types.RATECODE_FAIL)))
}

function* createRateCodeCampaign() {
    yield takeLatest(Types.RATECODE_CAMPAIGN_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(RateCodeServie.createRateCodeCampaign, action.campaign);
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.createSuccess')}`, description: `${i18n.t('item.ratecode.campaign')} "${action.campaign.name}"` });
        yield put({ type: Types.RATECODE_CAMPAIGN_CREATE_SUCCESS });
        yield delay(SAGA_DELAY_TIMEOUT)
        const result = yield call(RateCodeServie.getRateCodeCampaignList);
        yield put(RateCodeAction.setRateCodeCampaignList(result));
    }, errorHandleRateCode(Types.RATECODE_FAIL)))
}

function* getListRateCodeAll() {
    yield takeLatest(Types.RATECODE_LIST_ALL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(RateCodeServie.getRateCodeListAll, action.params);
        yield put(RateCodeAction.setRateCodeListAll(result));
    }, errorHandleRateCode(Types.RATECODE_FAIL)))
}

function* getListRateCodeWithPaging() {
    yield takeLatest(Types.RATECODE_LIST_WITH_PAGING_ACTION, function* (action) {
        try {
            const result = yield call(RateCodeServie.getRateCodeListWithPaging, action.params);
            yield put(RateCodeAction.setRateCodeListWithPaging(result));
            action.callbacks && action.callbacks.onSuccess && action.callbacks.onSuccess(result);
        } catch (e) {
            action.callbacks && action.callbacks.onError && action.callbacks.onError(e);
            yield errorHandleRateCode(Types.RATECODE_FAIL)(e, action);
        }
    })
}

function* getListRateCode() {
    yield takeLatest(Types.RATECODE_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseListRequestParamsCameo(action.params || {});
        const result = yield call(RateCodeServie.getRateCodeList, params);
        yield put(RateCodeAction.setRateCodeList(result));
    }, errorHandleRateCode(Types.RATECODE_FAIL)))
}

function* createRateCodeDetail() {
    yield takeLatest(Types.RATECODE_DETAIL_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(RateCodeServie.createRateCodeDetail, action.rateCode);
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.createSuccess')}`, description: `${i18n.t('item.ratecode.campaign')} "${action.rateCode.name}"` });
        yield put({ type: Types.RATECODE_DETAIL_CREATE_SUCCESS });
        history.push(PATHS.RATECODE.LIST.path);
        history.go();
    }, errorHandleRateCode(Types.RATECODE_FAIL)))
}

function* getRateCodeDetail() {
    yield takeLatest(Types.RATECODE_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(RateCodeServie.getRateCodeDetail, action.id);
        yield put(RateCodeAction.setRateCodeDetail(result));
    }, errorHandleRateCode(Types.RATECODE_FAIL)))
}

function* getRateCodeDetailCache() {
    yield takeEvery(Types.RATECODE_DETAIL_CACHE_ACTION, function* (action) {
        try {
            const result = yield call(RateCodeServie.getRateCodeDetail, action.id);
            yield put(RateCodeAction.setRateCodeDetailCache(result));
            action.callbacks && action.callbacks.onSuccess && action.callbacks.onSuccess(result);
        } catch (e) {
            action.callbacks && action.callbacks.onError && action.callbacks.onError(e);
            yield errorHandleRateCode(Types.RATECODE_FAIL)(e, action);
        }
    })
}

function* updateRateCodeDetail() {
    yield takeLatest(Types.RATECODE_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(RateCodeServie.updateRateCodeDetail, action.rateCode);
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.updateSuccess')}`, description: `${i18n.t('item.ratecode.name')} "${action.rateCode.name}"` })
        // yield put(RateCodeAction.setRateCodeDetail(action.rateCode));
        history.push(PATHS.RATECODE.LIST.path);
        history.go();
    }, errorHandleRateCode(Types.RATECODE_FAIL)))
}

function* getRateCodeSchedule() {
    yield takeLatest(Types.RATECODE_SCHEDULE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(RateCodeServie.getRateCodeSchedule, action.id);
        yield put(RateCodeAction.setRateCodeSchedule(result));
    }, errorHandleRateCode(Types.RATECODE_FAIL)))
}

function* createRateCodeSchedule() {
    yield takeLatest(Types.RATECODE_SCHEDULE_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(RateCodeServie.createRateCodeSchedule, action.rateCodeSchedule);
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.createSuccess')}`, description: `${i18n.t('item.ratecode.listSchedule')} "${action.rateCodeSchedule.name}"` })
        yield put({ type: Types.RATECODE_SCHEDULE_CREATE_SUCCESS });
        const result = yield call(RateCodeServie.getRateCodeSchedule, action.rateCodeSchedule.rateCodeId || "");
        yield put(RateCodeAction.setRateCodeSchedule(result));
        // history.push(PATHS.RATECODE.SCHEDULE.path);
        // history.go();
    }, errorHandleRateCode(Types.RATECODE_FAIL)))
}

function* lockRateCode() {
    yield takeLatest(Types.RATECODE_LOCK_ACTION, Func.sagaWrapper(function* (action) {
        yield call(RateCodeServie.lockRateCode, action.rateCode);
        Func.sagaSuccessMessage({ action, message: !action.rateCode.isActive ? `${i18n.t('notification.unLockSuccess')}` : `${i18n.t('notification.lockSuccess')}`, description: `${i18n.t('item.ratecode.name')} "${action.rateCode.name}"` });
        const result = yield call(RateCodeServie.getRateCodeList, action.params || {});
        yield put(RateCodeAction.setRateCodeList(result));
    }, errorHandleRateCode(Types.RATECODE_FAIL)))
}

// function* deleteTicketAssignConfig() {
//     yield takeLatest(Types.TICKET_ASSIGN_CONFIG_DELETE_ACTION, Func.sagaWrapper(function* (action) {
//         yield call(TicketService.deleteTicketAssignConfig, action.ticketAssignConfig.id);
//         Func.sagaSuccessMessage(action, i18n.t('notification.removeSuccess'));
//         yield put({ type: Types.TICKET_ASSIGN_CONFIG_DELETE_SUCCESS });
//         yield put({ type: Types.TICKET_ASSIGN_CONFIG_LIST_ACTION, params: action.refreshParams });
//     }, errorHandleTicket(Types.RATECODE_FAIL)))
// }

function errorHandleRateCode(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'rateCode');
}


function* getRateCodeUsagePlanDetail() {
    yield takeLatest(Types.RATECODE_USAGE_PLAN_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const {rateCode, callbacks } = action;
        const result = yield call(RateCodeServie.getRateCodeUsagePlanDetail, rateCode);
        callbacks && callbacks.onSuccess(result.data);

    }, errorHandleSupplier(Types.SUPPLIER_FAIL)))
}

function* getRateCodeProductDetail() {
    yield takeLatest(Types.STOCK_PRODUCTS_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(RateCodeServie.getStockProducts, action.params);
        yield put(RateCodeAction.setStockProducts(result.data));
    }, errorHandleRateCode(Types.RATECODE_FAIL)))
}

function errorHandleSupplier(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'ratecode');
}

export function* rateCodeSaga() {
    yield all([
        fork(getListRateCodeCampaign),
        fork(createRateCodeCampaign),
        fork(getListRateCodeAll),
        fork(getListRateCodeWithPaging),
        fork(getListRateCode),
        fork(createRateCodeDetail),
        fork(getRateCodeDetail),
        fork(getRateCodeDetailCache),
        fork(getRateCodeSchedule),
        fork(createRateCodeSchedule),
        fork(updateRateCodeDetail),
        fork(lockRateCode),
        fork(getRateCodeUsagePlanDetail),
        fork(getRateCodeProductDetail)
    ])
}
